import { jsx as _jsx } from "react/jsx-runtime";
import Renew16 from '@carbon/icons-react/es/renew/16';
import { Button } from '@rocketlane/ui';
import { useRef, useEffect } from 'react';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
export const RefreshButton = ({ onRefresh, delayInMs = 10000, dataCy = 'refresh-btn' })=>{
    const buttonRef = useRef(null);
    const isNew = useAntdRlUISwitcher();
    const timeoutRef = useRef(null);
    const isMountedRef = useRef(true);
    useEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);
    const handleClick = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (buttonRef.current) {
            onRefresh();
            // [RATE_LIMIT] Disable refresh button for `delayInMs` seconds
            buttonRef.current.style.pointerEvents = 'none';
            buttonRef.current.style.opacity = '0.5';
            // Clear any existing timeout before setting a new one
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(()=>{
                if (isMountedRef.current && buttonRef.current) {
                    buttonRef.current.style.pointerEvents = 'auto';
                    buttonRef.current.style.opacity = '1';
                }
                timeoutRef.current = null;
            }, delayInMs);
        }
    };
    return /*#__PURE__*/ _jsx(Button, {
        ref: buttonRef,
        variant: "secondary",
        type: "button",
        size: isNew ? 'medium' : 'small',
        leftIcon: /*#__PURE__*/ _jsx(Renew16, {}),
        onClick: handleClick,
        "data-cy": dataCy
    });
};
